import { plCatalogs } from '../pl/contract';

/** The vitality-restoring roll types. A self-zero ward rolling one is a Last Stand (tryLastStand, before death); any other waits for the
 *  terminal outcome (actualDeathTriggers). A leaf, so the pure swing planner can read it without the trigger executor. */
export const LAST_STAND_ROLL_TYPES: string[] = ['healing_roll', 'regeneration_roll', 'temporary_vitality_roll',
    'temporary_vitality_regeneration_roll', 'temporary_max_vitality_roll']
    .map(name => plCatalogs().rollTypes.getId(name)).filter((id): id is string => !!id);
